angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudentsReports', function ($http, $log, EventManager, userAccount, api,  DATA_HOST) {
  return {
    templateUrl: 'template.html',
    scope: {
      selectedClass: '='
    },
    link: function (scope, element) {

      var eventManager = new EventManager('teacherStudentsReports', scope);

    }
  }
});
